import { render, staticRenderFns } from "./backstart.vue?vue&type=template&id=077b8dbc&scoped=true"
import script from "./backstart.vue?vue&type=script&lang=js"
export * from "./backstart.vue?vue&type=script&lang=js"
import style0 from "./backstart.vue?vue&type=style&index=0&id=077b8dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077b8dbc",
  null
  
)

export default component.exports